<template>
  <div
    class="flex justify-between items-center p-1 border-b border-solid border-gray-100 last:border-b-0"
    :class="isCurrent ? 'bg-gray-100' : ''"
  >
    <div class="w-1/3 text-left">
      <h2 class="font-bold">{{ data.name }}</h2>
      <div class="flex flex-col">
        <span class="text-gray-500 text-sm" v-if="data.max_allocated_nodes">
          {{ data.max_allocated_nodes }} {{ data.nodes_unit }}**
        </span>
        <span class="text-gray-500 text-sm">
          <span class="font-bold">{{ data.current_occupation }}</span>
          {{ i18n.project }}<span v-if="data.current_occupation > 1">s</span>
          {{ i18n.queued }}
        </span>
      </div>
    </div>
    <span class="w-1/3 flex">
      <span class="font-normal">
        {{ price }}&nbsp;<span class="ranch-credit">€</span
        ><span class="text-gray-500">/{{ data.price_unit }}</span>
      </span>
      <span class="text-color" v-if="error">
        <font-awesome-icon icon="exclamation-circle" /> {{ error_message }}
      </span>
    </span>
    <ranch-button
      class="w-1/3 h-auto justify-around"
      :class="{ 'cursor-auto': !canBeSelected }"
      :action="css"
      :icon-after="true"
      :icon="canBeSelected ? 'arrow-right' : null"
      @click="selectPriority"
    >
      <div class="" v-if="isUpgrading">
        {{ i18n.label }} {{ i18n.increasing }}...
      </div>
      <div v-else-if="isCurrent && projectRank">
        {{ i18n.currently }} {{ i18n.position }}&nbsp;{{ projectRank }}
      </div>
      <div v-else>
        {{ i18n.choose }} {{ i18n.position }}&nbsp;{{ data.available_rank }}
      </div>
    </ranch-button>
  </div>
</template>

<script>
export default {
  props: [
    "data",
    "majoration",
    "projectRank",
    "isCurrent",
    "isUpgrading",
    "canBeSelected",
    "i18n",
    "hasLowerRankThanPrevious",
  ],
  data() {
    return {
      error: false,
      error_message: "",
    };
  },
  methods: {
    selectPriority() {
      if (this.canBeSelected) {
        this.$emit("priority-selected", this.data.id);
      }
    },
  },

  computed: {
    price() {
      return (this.majoration + parseFloat(this.data.ghz_h_price))
        .toString()
        .padEnd(5, 0);
    },
    css() {
      if (this.canBeSelected && !this.isUpgrading && !this.isCurrent) {
        let classes = "border-action";
        if (this.hasLowerRankThanPrevious) {
          classes += " action";
        } else {
          classes += " action-secondary";
        }
        return classes;
      }

      if (this.isCurrent) {
        return "bg-white border-2 border-solid border-gray-200";
      }

      if (this.isUpgrading) {
        return "bg-blue-100 border-2 border-solid border-blue-200";
      }

      if (!this.canBeSelected) {
        return "bg-gray-200 border-2 border-solid border-gray-300";
      }
      return "";
    },
  },
  mounted() {
    if (this.data.name.includes("ᴿ⁺")) {
      this.$emit("show-note", "ᴿ⁺", "note_more_ram");
    }
    if (this.data.name.includes("ⱽ⁺")) {
      this.$emit("show-note", "ⱽ⁺", "note_more_vram");
    }
  },
};
</script>
